/**
 * React Router 6 compatibility utilities
 * Provides withRouter HOC replacement for class components and redux containers
 */
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

/**
 * withRouter HOC replacement for React Router 6
 * Provides match, history, and location props for backward compatibility
 */
export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();

        // Create match-like object for backward compatibility
        const match = {
            params,
            pathname: location.pathname,
            url: location.pathname,
        };

        // Create history-like object for backward compatibility
        const history = {
            push: (path) => navigate(path),
            replace: (path) => navigate(path, { replace: true }),
            go: (n) => navigate(n),
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            location,
        };

        return (
            <Component
                {...props}
                match={match}
                history={history}
                location={location}
            />
        );
    }

    // Preserve display name for debugging
    const displayName = Component.displayName || Component.name || 'Component';
    ComponentWithRouterProp.displayName = `withRouter(${displayName})`;

    return ComponentWithRouterProp;
}
